import React from 'react';
import OLYWebPageComponent from '../components/OLYWebPageComponent';
import { translate } from 'react-i18next';
import { LinearProgress, CircularProgress } from 'material-ui';
import { Typography } from 'material-ui';
import { Grid } from 'material-ui';
import { withStyles } from 'material-ui';
import { getCMSConfiguration, getCMSWidgetClassByObject } from './cmsLib';
import { Button } from 'material-ui';


const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    }
});
class News extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showLoadMore: true,
            limit: 10,
            news: []
        };
        this.pageName = 'NEWS';
        this.cmsConfiguration = getCMSConfiguration();
        this.getNewsAsync();
    }

    async getNewsAsync() {
        let rooturl = process.env.REACT_APP_API_URL;
        let total = this.state.news.length;
        let limit = this.state.limit;
        let lang = this.getUserLang();
        let url = `${rooturl}masterdata/news?lang=${lang}&limit=${limit}`;
        const response = await fetch(url);
        let news;
        try {
            news = await response.json();
            news.map(h => {
                h.type = 'NewsItemWidget';
                h.action = { type: 'NavigateToURL' };
                h.action.request = h;
            });
        } catch (error) {
            news = [];
        }
        let slm = news.length >= 10 && total != news.length;
        this.setState({
            news: news,
            showLoadMore: slm,
            loading: false,
        });
    }



    loadMoreNews = () => {
        this.setState({
            loading: true,
            limit: this.state.limit + 10,
        }, () => {
            this.getNewsAsync();
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="cmsNews">
                <div className="cmsContainer">
                    <div style={{ margin: '5px' }}>
                        {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    </div>
                    <Typography variant="title">{t(this.pageTitle)}</Typography>
                    <div style={{ padding: 8 }}>
                        <Grid container justify="center">
                            <Grid item xs={6}>
                                <Typography></Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography></Typography>
                            </Grid>
                        </Grid>
                    </div>
                    <div style={{ padding: 8 }}>
                        <Grid container>
                            {
                                this.state.news.map(newitem => {
                                    let Clazz = getCMSWidgetClassByObject(newitem);
                                    return <Grid item xs={4} key={newitem.id}>
                                        <Clazz newsItem={newitem} parameters={{ displayImage: true }} />
                                    </Grid>;
                                })
                            }
                        </Grid>
                    </div>
                    <div style={{ textAlign: 'center', width: '100%' }}>
                        {this.state.showLoadMore ?
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={this.loadMoreNews}
                                className="cmsButtonSearch">
                                {this.state.loading && <CircularProgress size={24} className="buttonProgressIcon" />}
                                {t('NEWS.LOAD_MORE')}
                            </Button>
                            : ''}
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(News));


// WEBPACK FOOTER //
// ./src/cms/News.js